import { useDispatch, useSelector } from 'react-redux';
import { confirmEmail, confirmEmailReset } from './actions';
import { useEffect } from 'react';

export function useConfirmEmail() {
  const { isEmailConfirmed, loading, error } = useSelector(state => state.confirmEmail);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(confirmEmailReset())
  }, [dispatch]);

  return {
    onConfirmEmail: (email) => dispatch(confirmEmail(email)),
    isEmailConfirmed,
    loading,
    error,
  }
}
